import { ChartFilterType, DataDescriptorEntity, Filter, SiteEntity } from "@ctra/api";
import * as _ from "lodash";
import { Nullable } from "@ctra/utils";

/**
 * Make default data filters for the given variants
 * @param {DataDescriptorEntity[]} variants
 * @param {SiteEntity} siteContext
 * @returns {Record<string, Filter[]>}
 */
export const makeDefaultDataFilters = (
  variants: Nullable<DataDescriptorEntity[]>,
  siteContext?: Nullable<SiteEntity>
) => {
  return _.isNil(variants)
    ? {}
    : _.reduce(
        variants,
        (acc, variant) => {
          if (variant && _.has(variant.filters, ChartFilterType.siteId)) {
            acc[variant.id] = [
              {
                type: ChartFilterType.siteId,
                values: siteContext ? [siteContext.id] : []
              }
            ];
          }

          return acc;
        },
        {} as Record<DataDescriptorEntity["id"], Filter[]>
      );
};

/**
 * Change format of filters from type: "", value: "" to [key]: value
 */
export const formatFilters = (
  dataFilters: Record<DataDescriptorEntity["id"], Filter[]>
): Record<DataDescriptorEntity["id"], Record<string, unknown>> =>
  _.mapValues(dataFilters, (filters) =>
    _.reduce(
      filters,
      (acc: Record<string, unknown>, item) => {
        // const newType = seriesToFilterMap[item.type];

        acc[item.type] = item.values;

        return acc;
      },
      {}
    )
  );
